module.exports = __webpack_public_path__ + "img/kanelsnurrer_haev.1fe77fc0.jpg";